module.exports = __webpack_public_path__ + "img/04.b0b695de.jpg";